import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ContentCutIcon from '@mui/icons-material/ContentCut';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Container from '@mui/material/Container';
import AdminAuth from './AdminAuth';
import './Navbar.css';

function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleAdminClick = (e) => {
    e.preventDefault();
    const isAuthenticated = sessionStorage.getItem('adminAuthenticated') === 'true';
    if (!isAuthenticated) {
      setLoginOpen(true);
    } else {
      window.location.href = '/admin';
    }
  };

  const menuItems = [
    { text: 'Home', path: '/' },
    { text: 'Services', path: '/services' },
    { text: 'Appointment', path: '/appointment' },
    { text: 'Walk-In', path: '/walkin' },
    { text: 'Contact', path: '/contact' },
    { text: 'Admin', path: '/admin', onClick: handleAdminClick }
  ];

  const drawer = (
    <Box className="mobile-menu">
      <List>
        {menuItems.map((item) => (
          <ListItem 
            button 
            key={item.text}
            component={Link}
            to={item.path}
            className={location.pathname === item.path ? 'active' : ''}
            onClick={(e) => {
              if (item.onClick) {
                item.onClick(e);
              }
              handleDrawerToggle();
            }}
          >
            <ListItemText primary={item.text} />
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <>
      <AppBar 
        position="fixed" 
        className={`navbar ${isScrolled ? 'scrolled' : ''}`}
        elevation={0}
      >
        <Container maxWidth="xl">
          <Toolbar className="navbar-container" disableGutters>
            <Link to="/" className="navbar-logo">
              <ContentCutIcon className="logo-icon" />
              <Typography variant="h8" component="div" style={{ whiteSpace: 'nowrap' }}>
                Noureddine Style
              </Typography>
            </Link>

            {!isMobile ? (
              <Box className="nav-links">
                {menuItems.map((item) => (
                  <Link
                    key={item.text}
                    to={item.path}
                    className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
                    onClick={item.onClick}
                    style={{ whiteSpace: 'nowrap' }}
                  >
                    {item.text}
                  </Link>
                ))}
                <Button 
                  variant="contained" 
                  color="primary"
                  component={Link}
                  to="/appointment"
                  className="book-button"
                >
                  <span style={{ whiteSpace: 'nowrap' }}>Book Now</span>
                </Button>
              </Box>
            ) : (
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
              >
                <MenuIcon />
              </IconButton>
            )}
          </Toolbar>
        </Container>

        <Drawer
          variant="temporary"
          anchor="right"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
        >
          {drawer}
        </Drawer>
      </AppBar>

      <AdminAuth 
        open={loginOpen} 
        onClose={() => setLoginOpen(false)} 
      />
    </>
  );
}

export default Navbar;
